import {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { listarInventarioUseCase } from "../../../core/inventarios/application/listarInventario.usecase.js";

/**
 * InventarioContext
 * -----------------
 * Contexto de solo lectura para el inventario.
 * Permite:
 * - Acceder al inventario cargado
 * - Saber si está cargando
 * - Recargar inventario con filtros dinámicos
 */
const InventarioContext = createContext(null);

// Hook seguro para consumir el contexto
export const useInventario = () => {
  const context = useContext(InventarioContext);
  if (!context) {
    throw new Error("useInventario debe usarse dentro de InventarioProvider");
  }
  return context;
};

export function InventarioProvider({ children }) {
  const [inventario, setInventario] = useState([]);
  const [loading, setLoading] = useState(false);

  const cargarInventario = useCallback(async (filtros = {}) => {
    setLoading(true);
    try {
      const data = await listarInventarioUseCase(filtros);
      setInventario(data); 
      console.log("InventarioContext.cargarInventario Inventario cargado:", data);
    } catch (error) {
      console.error("Error cargando inventario:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  /**
   * Carga inicial del inventario
   */
  useEffect(() => {
    cargarInventario();
  }, [cargarInventario]);

  return (
    <InventarioContext.Provider
      value={{
        inventario,
        loading,
        cargarInventario,
      }}
    >
      {children}
    </InventarioContext.Provider>
  );
}
